import api from '../api';

const updateProjectTool = ({ id, programToolId, status }) =>
  api.patch(`/api/project-program-tools/${id}/`, { id, status });

export default {
  updateProjectTool,
};
